import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initFingerprintAutoload, loadFingerprintIfNeeded } from './utils/fingerprint';

// Initialize auto-loading of fingerprint on page load and button clicks
initFingerprintAutoload();
// Also attempt early in startup in case load event already fired in fast refresh
void loadFingerprintIfNeeded('startup');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
